import { render, staticRenderFns } from "./AxProjectState.vue?vue&type=template&id=9e011b2a&"
import script from "./AxProjectState.vue?vue&type=script&lang=ts&"
export * from "./AxProjectState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports